import Swal from "sweetalert2";

type iconType = "success" | "warning" | "error" | "question";

interface AlertOptions {
    confirmMode?: boolean;  // confirm 모드 on/off
    onCancel?: Function;    // confirm 모드 시 취소 콜백
    htmlMode?: boolean;     // html 태그 허용 여부
    didOpen?: () => void;   // 알림창 열린 후 실행 콜백 추가
    didClose?: () => void;   // 알림창 닫힌 후 실행 콜백
}


let alertQueue: Promise<any> = Promise.resolve();

export function showAlert(options: any) {
  alertQueue = alertQueue.then(() => Swal.fire(options));
  return alertQueue;
}
export default async function customAlert(
    message: string,
    icon: iconType,
    onChecked?: Function,
    options: AlertOptions = {}
) {
    const { confirmMode = false, onCancel, htmlMode = false, didOpen, didClose } = options;

    const swalOptions: any = {
        heightAuto: false,
        icon,
        confirmButtonText: "확인",
        cancelButtonText: "취소",
        showCancelButton: confirmMode,
        didOpen,
        didClose,
    };

    if (htmlMode) {
        swalOptions.html = message;
    } else {
        swalOptions.text = message;
    }
    const result = await showAlert(swalOptions);

    if (result.isConfirmed && onChecked) {
        onChecked();
    } else if (confirmMode && result.isDismissed && onCancel) {
        onCancel();
    }
}